export const HELP_TOPICS = {
    'ticket.priority': {
        short: 'P1 (Critical) — business stopped. P2 (High) — major impact, workaround possible. ' +
            'P3 (Normal) — minor impact. P4 (Low) — cosmetic / nice-to-have.',
        articleSlug: 'understanding-priority-impact-urgency',
    },
    'ticket.type': {
        short: 'Incident = something broken (VPN down, printer jammed). Service Request = ' +
            'a planned ask (new user, software install).',
        articleSlug: 'understanding-priority-impact-urgency',
    },
    'ticket.channel': {
        short: 'How this ticket reached you. Manual = walk-in / verbal. Phone = customer ' +
            'called. Email = transcribing from a mailbox. Chat = chat handoff.',
    },
    'ticket.serviceLocation': {
        short: 'Where the work needs to happen. Type any address freely; suggestions appear ' +
            'from this client\'s registered sites. Picking a suggestion attaches the ' +
            'site\'s timezone to the SLA timer.',
    },
    'ticket.requester': {
        short: 'The customer this ticket is FOR (the person whose problem it is). Different ' +
            'from "Created by" — that\'s you, the agent doing the data entry.',
    },
    'ticket.impact': {
        short: 'How WIDELY it is felt — one person, a team, or a whole site. Combined with ' +
            'Urgency to land on a Priority.',
        articleSlug: 'understanding-priority-impact-urgency',
    },
    'ticket.urgency': {
        short: 'How FAST it must be fixed — separate from how many it affects. Combined with ' +
            'Impact to land on a Priority.',
        articleSlug: 'understanding-priority-impact-urgency',
    },
    'field.timeBlock': {
        short: 'How long the visit is booked for. Full day / Half day auto-fill the duration ' +
            'from working hours; pick Custom to set your own.',
        articleSlug: 'scheduling-visits-and-poc-contact',
    },
    'field.ladder': {
        short: 'Whether the engineer needs a ladder on site, and which type — capture it so ' +
            'they arrive equipped.',
        articleSlug: 'editing-a-ticket',
    },
    // --- Reports / Insights KPI definitions (§37) — state the exact meaning so
    //     every number is trustworthy. These describe the formulas AS BUILT. ---
    'report.slaCompliance': {
        short: 'Of all tickets in scope, the share that have NOT breached their resolution ' +
            'SLA = (1 − resolution-breached ÷ total) × 100. Counts open + resolved tickets ' +
            '(not just closed); resolution target only.',
    },
    'report.aging': {
        short: 'Open tickets (excludes Closed / Cancelled) grouped by how long ago they were ' +
            'created: 0–24h, 1–3d, 3–7d, >7d.',
    },
    'report.currentBreaches': {
        short: 'Open or not, the count of tickets currently flagged as having breached their resolution SLA.',
    },
    'report.mttr': {
        short: 'Mean time to resolve = average of (resolved time − created time) across resolved tickets, in hours.',
    },
    'report.firstTimeFix': {
        short: 'Of tickets that had at least one completed visit in the window, the share fixed ' +
            'in exactly ONE visit.',
    },
    'report.onsiteSla': {
        short: 'Of dispatch tickets carrying an on-site arrival target in the window, the share ' +
            'that met it (did not breach).',
    },
    'report.nps': {
        short: 'Net Promoter Score = %promoters (rated 9–10) − %detractors (0–6), range −100…+100. ' +
            'Passives (7–8) count toward the total but not the score.',
    },
    'report.ces': {
        short: 'Customer Effort Score — average of the "how easy was it" rating (1–7; lower is better).',
    },
    'report.csat': {
        short: 'Average overall satisfaction rating (1–5) across submitted CSAT responses.',
    },
};
